'use client';

import { APP_SIDE_NAV_WIDTH } from '@side/pantry';
import dynamic from 'next/dynamic';
import type { PropsWithChildren } from 'react';

const AgentPageLayout = dynamic(
  () =>
    import('./AgentPageLayout').then((mod) => ({
      default: mod.AgentPageLayout,
    })),
  {
    ssr: false,
    // Placeholder to prevent layout shift
    loading: () => <div style={{ width: `${APP_SIDE_NAV_WIDTH}px` }} />,
  },
);

export function AgentPageLayoutClient({
  children,
  hideSidebar,
}: PropsWithChildren & { hideSidebar?: boolean }) {
  return (
    <AgentPageLayout hideSidebar={hideSidebar}>{children}</AgentPageLayout>
  );
}
